export enum RainforestPaymentMethodEnum {
    Card = 'CARD',
    Ach = 'ACH',
    ValidatedAch = 'VALIDATED_ACH',
    ApplePay = 'APPLE_PAY',
}